import { FormRenderProps } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

import { Button, Card, CardContent } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer } from '@occc-app/design-system';
import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';

import { breadcrumbLinks } from './constants';

import { FormContent } from '../components/FormContent';
import { UserFormValues } from '../types';

type CreateUserFormRenderComponentProps = Pick<FormRenderProps<UserFormValues>, 'handleSubmit'> & {
  disabled: boolean;
};

export const CreateUserFormRenderComponent = ({
  handleSubmit,
  disabled,
}: CreateUserFormRenderComponentProps) => {
  const navigate = useNavigate();

  useAppLayoutContextConsumer(breadcrumbLinks);

  const actions = [
    <Button variant='outlined' onClick={() => navigate(-1)} key='cancel'>
      Cancel
    </Button>,
    <Button
      key='save'
      variant='contained'
      color='primary'
      onClick={handleSubmit}
      disabled={disabled}
    >
      Save
    </Button>,
  ];

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <FormLayout actions={actions}>
          <CardContent>
            <FormContent />
          </CardContent>
        </FormLayout>
      </Card>
    </form>
  );
};
